import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import AlertMessage from "../../include/AlertMessage";
var _ = require("lodash");

function EditCoursebooking() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;
    
    const [alert, setAlert] = useState({ type: "", message: "" });
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem("JWT_TOKEN");
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        paymentID: "",
        paymentGateway: "",
        paymentStatus: false,
        users: "",
        userEmail: "",
        courses: "",
        ticketID: ""
    });

    const [allUsers, setallUsers] = useState([]);
    const [allCourses, setAllCourses] = useState([]);


    const fetchAllUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/customers`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });
            const userdata = await response.data;
            if (Array.isArray(userdata.data) && userdata.data.length > 0) {
                setallUsers(userdata.data);
            } else {
                setallUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }

    };

    const fetchAllCourses = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/courses`, {
                params: {
                    latitude: 0,
                    longitude: 0,
                    radius: 0
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });
            const eventdata = await response.data;
            if (Array.isArray(eventdata.data) && eventdata.data.length > 0) {
                setAllCourses(eventdata.data);
            } else {
                setAllCourses([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };


    // Define an async function inside useEffect
    const fetchData = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetchcoursebookingdetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;
            const customdata = {
                paymentID: resdata.paymentID || "",
                paymentGateway: resdata.paymentGateway || "",
                paymentStatus: resdata.paymentStatus || false,
                users: resdata?.users,
                courses: resdata?.courses,
                ticketID: resdata?.ticketID || ""
            }
            setFormData(customdata); // Set data to state
            //setIsToggled(resdata.isActive);
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000); // Adding a slight delay for better UX            
        }
    };


    useEffect(() => {
        document.documentElement.className = "";

        fetchAllUsers();
        fetchAllCourses();
        fetchData(); // Call the async function                
    }, [id]);


    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/courses" className='btn btn-primary'>Holidays</Link></li>
                        <li><Link to={`/coursebookings/${formData.courses}?page=${page}`} className='btn btn-primary'>Bookings</Link></li>
                        <li>Edit</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit booking {/* Add booking to {name} */}
                            </p>
                        </header>
                        <div className="card-content">
                            {alert.message && (
                                <AlertMessage
                                    type={alert.type}
                                    message={alert.message}
                                    onClose={() =>
                                        setAlert({
                                            type: "",
                                            message: "",
                                        })
                                    }
                                />
                            )}

                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">
                                                Course Name
                                            </label>

                                            <div className="control">
                                                <input
                                                    type="text"
                                                    className="input"
                                                    value={
                                                        allCourses.find(
                                                            (course) => course.$id === formData.courses
                                                        )?.name || ""
                                                    }
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="field">
                                            <label className="label">
                                                User Email
                                            </label>

                                            <div className="control">
                                                <input
                                                    type="text"
                                                    className="input"
                                                    value={
                                                        allUsers.find(
                                                            (user) => user.$id === formData.users
                                                        )?.email || ""
                                                    }
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">
                                                Ticket ID
                                            </label>

                                            <div className="control">
                                                <input
                                                    type="text"
                                                    className="input"
                                                    value={formData.ticketID || ""}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="field">
                                            <label className="label">
                                                Payment Gateway
                                            </label>

                                            <div className="control">
                                                <input
                                                    type="text"
                                                    className="input"
                                                    value={formData.paymentGateway}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">
                                                Payment Status
                                            </label>

                                            <div className="control">
                                                <input
                                                    type="text"
                                                    className="input"
                                                    value={
                                                        formData.paymentStatus
                                                            ? "Paid"
                                                            : "Pending"
                                                    }
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center mt-5">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button
                                                    type="button"
                                                    className="button red"
                                                    onClick={() =>
                                                        redirectHistory(
                                                            `/coursebookings/${formData.courses}?page=${page}`
                                                        )
                                                    }
                                                >
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditCoursebooking;